import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom, concatMap, mapTo } from 'rxjs/operators';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import * as fromAction from '../actions/session.actions';
import * as fromUI from '../actions/ui.actions';
import { of } from 'rxjs';
import { InvoiceService } from '../../shared/services/invoice.service';
import { PrestationService } from '../../shared/services/prestation.service';
import { NotificationsService } from '../../shared/notifications/notifications.service';
import { Location } from '@angular/common';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable()
export class SessionEffext {

    constructor(
        private actions$: Actions,
        private store: Store<any>,
        private router: Router,
        private invoiceService: InvoiceService,
        private prestationService: PrestationService,
        private notificationsService: NotificationsService,
        private _location: Location,

    ) {}
}
